import { useState, useEffect, useRef } from "react";
import { Grid,  TextField,  Button,  IconButton,  Paper, Typography, MenuItem} from "@material-ui/core";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Delete as DeleteIcon, Add as AddIcon, DragIndicator } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "../../atoms/dialog";
import { generatedLLMComponents } from '../../../store/global/selectors'
import { generateLlmComponents, handleSnackBar, invokePostService, setLlmModel, showAcceptRejectButtons } from "../../../store/global/actions";
import ListSubheader from '@material-ui/core/ListSubheader';

function FlowGenerator({setLLMFlow}) {
  const draggableParentRef = useRef()
  const [fields, setFields] = useState([
    { name: "crop", type: "DigitalTwin", description:"Dtwin" },
    { name: "farm", type: "http_delegate", description:"Delegate" },
    { name: "admin", type: "Sensor", description:"Sensor" },
  ]);

  const [open, setOpen] = useState(false);
  const llmComponents = useSelector(generatedLLMComponents);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()


  const delegateOptions = [
    { label: "MySQL Delegate", value: "mysql_delegate" },
    { label: "HTTP/1.1 Protocol Delegate", value: "http_delegate" },
    { label : "CV Delegate", value : "cv_delegate"},
    { label : "Controller Delegate", value : "controller_delegate"}
  ];
  
  const nodeOptions = [
    { label: "Digital Twin", value: "digitaltwin" },
    { label: "Sensor", value: "sensor" },
    { label: "Clusterlet", value: "clusterlet" },
    { label: "Enterprise App", value: "enterprise" },

  ];

  useEffect(() => {
    if(llmComponents.status && llmComponents?.data?.components != undefined && Array.isArray(llmComponents?.data?.components) && llmComponents?.data?.components.length > 0){
      console.log("Rendering-----2------", llmComponents.data.components)

      const updatedComponents = llmComponents.data.components.map(comp => ({
        ...comp,
        type: comp.type && comp.type.trim() !== "" ? comp.type : "digitaltwin"
      }));

      setOpen(true);
      setFields(updatedComponents)
    }
    else{
      setOpen(false)
      setFields([])
    }
  }, [llmComponents])


  // Handle reorder
  const handleDragEnd = (result) => {
    if (!result.destination) return;
  
    // Deep clone the fields to avoid stale references
    const reordered = JSON.parse(JSON.stringify(fields));
    
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    
    setFields(reordered);
  };
  // Handle add
  const handleAdd = () => {
    setFields([...fields, { name: "", type: "" }]);
  };

  // Handle delete
  const handleDelete = (index) => {
    const updated = JSON.parse(JSON.stringify(fields.filter((_, i) => i !== index)));
    setFields(updated);
  };
  const handleClose = () => {
    setOpen(false);
  }

  const getTypeOptionsAndSelected = (type = "") => {
    if (!type || type.trim() === "") {
      const defaultNode = nodeOptions.find((o) => o.value === "digitaltwin");
      return { group: "node", options: nodeOptions, selected: defaultNode };
    }
    const t = type.toLowerCase();
  
    for (const opt of delegateOptions) {
      if (t.includes(opt.value)) {
        return { group: "delegate", options: delegateOptions, selected: opt };
      }
    }
  
    if (t.includes("delegate")) {
      const httpOption = delegateOptions.find((o) => o.value === "http_delegate");
      return { group: "delegate", options: delegateOptions, selected: httpOption };
    }
  
    for (const opt of nodeOptions) {
      if (t.includes(opt.value)) {
        return { group: "node", options: nodeOptions, selected: opt };
      }
    }
  
    const defaultNode = nodeOptions.find((o) => o.value === "digitaltwin");
    return { group: "node", options: nodeOptions, selected: defaultNode };
  };

  const handleSubmitModel = async () => {

    if (fields.length == 0) return;
    setLoading(true);

    const clonedFields = JSON.parse(JSON.stringify(fields));

    // const sanitizedFields = fields.map(comp => ({
    //   ...comp,
    //   type: comp.type && comp.type.trim() !== "" ? comp.type : "digitaltwin"
    // }));

    const sanitizedFields = clonedFields.map((comp) => ({
      ...comp,
      name: comp?.name?.trim() || "",
      description: comp?.description?.trim() || "",
      type: comp?.type && comp?.type.trim() !== "" ? comp?.type.trim() : "digitaltwin",
    }));

    console.log("Sanitize-----", sanitizedFields)

    try {
      dispatch(invokePostService('llmGenerateFlow', { components: sanitizedFields }, []))
        .then((response) => {           
          if (response.status) {
            dispatch(setLlmModel(response?.system_model_flows))
            dispatch(showAcceptRejectButtons(true));
            dispatch(generateLlmComponents({ status: false, data: null }));
            setOpen(false);
            setLLMFlow(response?.system_model_flows)
          } else {
            dispatch(generateLlmComponents({ status: false, data: null }));
            dispatch(handleSnackBar({ open: true, message: response.message, severity: "error" }));
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error)
          setLoading(false);
        });
    } catch (err) {
      console.error("Error submitting query", err);
    } finally {
    }
  }
  

  
  return (
    <Dialog open={open} container_id="flow-generator" handleClose={handleClose} >
      <Grid
        container
        direction="column"
        style={{ gap: "1rem", padding: "0.3rem 0.5rem", maxWidth: "70rem",width :"100%" }}
        className="no-drag"
      >

        {/* <Grid container style={{ fontWeight: "bold", padding: "0.5rem", background: "#f5f5f5", borderRadius: 4, }} > */}
          <div style={{paddingLeft: '24px', paddingRight: '48px', fontWeight: 600}}>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={3}>
                <Typography style={{width: '100%', textAlign: "center"}}>Name</Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography style={{width: '100%', textAlign: "center"}}>Type</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography style={{width: '100%', textAlign: "center"}}>Description</Typography>
              </Grid>
            </Grid>
          </div>

      
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="fields">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  padding: "0.3rem 0.5rem",
                  maxHeight: "60vh",
                }}
                >
                  {fields.map((field, index) => {
                    const { group, options, selected } = getTypeOptionsAndSelected(field?.type);

                    return (
                      <Draggable
                        key={index}
                        draggableId={String(index)}
                        index={index}
                      >
                        {(provided, snapshot) => (

                          <div // CHANGE: Use Grid container here
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              marginBottom: "0.5rem",
                              background: snapshot.isDragging ? "#f0f0f0" : "white",
                              zIndex: snapshot.isDragging ? 1000 : "auto",
                              width: snapshot.isDragging ? `${provided.draggableProps.style.width}px` : "100%",
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                              // width:"100%"
                            }}
                          >
                            <div>
                              <div {...provided.dragHandleProps}>
                                <DragIndicator style={{ cursor: "grab" }} />
                              </div>
                            </div>

                            <Grid container spacing={1}>
                              {/* Name input */}
                              <Grid item xs={3}>
                                <TextField
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={field?.name || ""}
                                  onChange={(e) => {
                                    const updated = [...fields];
                                    updated[index].name = e.target.value;
                                    setFields(updated);
                                  }}
                                  id={`node_name_${index}`}
                                />
                              </Grid>

                              {/* Type dropdown */}
                              <Grid item xs={3}>
                                <TextField
                                  select
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={selected?.value} // store the value
                                  onChange={(e) => {
                                    const updated = [...fields];
                                    updated[index].type = e.target.value;
                                    setFields(updated);
                                  }}
                                  id={`node_type_${index}`}
                                >
                                  <ListSubheader disableSticky={true}>Delegates</ListSubheader>
                                  {delegateOptions.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </MenuItem>
                                  ))}
                                  <ListSubheader disableSticky={true}>Clusterlets</ListSubheader>
                                  {nodeOptions.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Grid>

                              {/* Description */}
                              <Grid item xs={6}>
                                <TextField
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  value={field?.description || ""}
                                  onChange={(e) => {
                                    const updated = [...fields];
                                    updated[index].description = e.target.value;
                                    setFields(updated);
                                  }}
                                />
                              </Grid>
                            </Grid>

                            {/* Delete button */}
                            <div>
                              <IconButton onClick={() => handleDelete(index)}>
                                <DeleteIcon />
                              </IconButton>
                            </div>
                            {/* </Paper> */}
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          
        {/* </Grid> */}

        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          style={{ textTransform: "capitalize", marginTop: "0.5rem" }}
        >
          Add Delegate/Clusterlet/Sensor
        </Button>

        {/* Action buttons */}
        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
          <Button variant="contained" style={{ background: "#ccc", textTransform: "capitalize", marginLeft: 10}} onClick={handleClose} alignItems="right">
            Close
          </Button>
          <Button variant="contained" color="primary" style={{ textTransform: "capitalize" ,marginLeft: 10}} onClick={handleSubmitModel} alignItems="right" disabled={loading}>
            {loading ? "Generating.." : "Generate"}
          </Button>

        </Grid>
      </Grid>
    </Dialog>
  );
}

export default FlowGenerator;
